import {useSyncExternalStore} from 'react';
import {readConsent, subscribeConsent, type Consent} from '@/lib/consent';

/** Cookie consent for Client Components; `null` on the server and during hydration. */
export const useConsent = (): Consent | null => useSyncExternalStore(subscribeConsent, readConsent, () => null);
